// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host(.show-close-icon) .real-input .boxx-hidden-input-close-icon {
  display: block;
}

.fake-input {
  --min-height: var(--boxx-fakeinput-min-height, 64px);
  font-size: 21px;
  font-weight: 700;
  color: var(--fakeinput-icon-color, var(--ion-color-secondary));
  text-align: var(--fakeinput-align, center);
  color: var(--fakeinput-color, var(--ion-color-secondary));
}

.real-input {
  --min-height: var(--boxx-realinput-min-height, 64px);
}
.real-input ::ng-deep ion-input,
.real-input ::ng-deep ion-textarea {
  font-size: 21px;
  font-weight: 700;
  color: var(--realinput-color, var(--ion-color-secondary));
  text-align: var(--realinput-align, center);
}
.real-input ::ng-deep ion-textarea textarea {
  overflow: hidden;
}
.real-input .boxx-hidden-input-close-icon {
  width: 28px;
  height: 28px;
  margin-top: var(--realinput-icon-margin-top, 18px);
  margin-bottom: var(--realinput-icon-margin-bottom, 18px);
  color: var(--realinput-icon-color, var(--ion-color-secondary));
  display: none;
}

ion-item {
  --padding-start: 24px;
  --padding-end: 24px;
  --inner-padding-end: var(--item-inner-padding-end, 0);
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/onboarding-core/lib/components/hidden-input-item/hidden-input-item.component.scss"],"names":[],"mappings":"AACE;EACE,cAAA;AAAJ;;AAIA;EACE,oDAAA;EACA,eAAA;EACA,gBAAA;EACA,8DAAA;EACA,0CAAA;EACA,yDAAA;AADF;;AAIA;EACE,oDAAA;AADF;AAEE;;EAEE,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,0CAAA;AAAJ;AAII;EACE,gBAAA;AAFN;AAME;EACE,WAAA;EACA,YAAA;EACA,kDAAA;EACA,wDAAA;EACA,8DAAA;EACA,aAAA;AAJJ;;AAOA;EACE,qBAAA;EACA,mBAAA;EACA,qDAAA;AAJF","sourcesContent":[":host(.show-close-icon) {\n  .real-input .boxx-hidden-input-close-icon {\n    display: block;\n  }\n}\n\n.fake-input {\n  --min-height: var(--boxx-fakeinput-min-height, 64px);\n  font-size: 21px;\n  font-weight: 700;\n  color: var(--fakeinput-icon-color, var(--ion-color-secondary));\n  text-align: var(--fakeinput-align, center);\n  color: var(--fakeinput-color, var(--ion-color-secondary));\n}\n\n.real-input {\n  --min-height: var(--boxx-realinput-min-height, 64px);\n  ::ng-deep ion-input,\n  ::ng-deep ion-textarea {\n    font-size: 21px;\n    font-weight: 700;\n    color: var(--realinput-color, var(--ion-color-secondary));\n    text-align: var(--realinput-align, center);\n  }\n\n  ::ng-deep ion-textarea {\n    textarea {\n      overflow: hidden;\n    }\n  }\n\n  .boxx-hidden-input-close-icon {\n    width: 28px;\n    height: 28px;\n    margin-top: var(--realinput-icon-margin-top, 18px);\n    margin-bottom: var(--realinput-icon-margin-bottom, 18px);\n    color: var(--realinput-icon-color, var(--ion-color-secondary));\n    display: none;\n  }\n}\nion-item {\n  --padding-start: 24px;\n  --padding-end: 24px;\n  --inner-padding-end: var(--item-inner-padding-end, 0);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
